<template>
    <div>
        <el-form ref="form" :model="form" :rules="rules" label-width="120px" style="width: 600px;">
            <el-form-item label="管理员名称" prop="nikeName">
                <el-input v-model="form.nikeName" placeholder="请输入管理员名称"></el-input>
            </el-form-item>
            <el-form-item label="角色" prop="roleIdList">
                <el-select v-model="form.roleIdList" multiple>
                    <el-option v-for="item in roles" :key="item.id" :value="item.id" :label="item.roleName"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
                <el-input v-model="form.phone" placeholder="请输入手机号" autocomplete="new-tel"></el-input>
            </el-form-item>
            <el-form-item label="管理员账号" prop="username">
                <el-input v-model="form.username" placeholder="请输入管理员账号" autocomplete="new-tel"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
                <el-input type="password" v-model="form.password" placeholder="请输入密码" show-password
                    autocomplete="new-password"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button @click="$router.back()">取消</el-button>
                <el-button type="primary" @click="handleSave">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { add, edit, detail } from "@/api/permission/admin";
import { page } from "@/api/permission/role";
export default {
    data() {
        return {
            id: null,
            roles: [],
            form: {
                nikeName: "",
                roleIdList: [],
                phone: "",
                username: "",
                password: "",
                status: 1
            },
            rules: {
                nikeName: [{ required: true, message: '请输入管理员名称' }],
                phone: [{ required: false, message: '请输入手机号' }],
                username: [{ required: true, message: '请输入管理员账号' }],
                password: [{ required: true, message: '请输入密码' }],
                roleIdList: [{ required: true, message: '请选择角色' }]
            }
        }
    },
    mounted() {
        this.id = this.$route.query.id;
        if (this.id) {
            this.getDetail();
        }
        this.getRoles();
    },
    methods: {
        getRoles() {
            page({
                pageNo: 1,
                pageSize: 9999

            }).then(({ code, result, message }) => {
                if (code == 200) {
                    this.roles = result.records || [];
                } else {
                    this.$message.error(message);
                }
            })
        },
        getDetail() {
            detail({ id: this.id }).then(({ code, result }) => {
                if (code == 200) {
                    this.form = result;
                }
            })
        },
        handleSave() {
            this.$refs.form.validate(valid => {
                if (!valid) return;
                const params = {
                    ...this.form
                }
                if (!this.id) {
                    add(params).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success("添加成功");
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    })
                } else {
                    params.id = this.id;
                    edit(params).then(({ code, message }) => {
                        if (code == 200) {
                            this.$message.success("修改成功");
                            this.$router.back();
                        } else {
                            this.$message.error(message);
                        }
                    })
                }
            })
        }
    }
}
</script>

<style></style>